import { useEffect, useRef } from 'react';

import { UseDrawerFocusArgs } from '../drawer.types';

export const useDrawerFocus = ({ drawerRef, isOpen }: UseDrawerFocusArgs) => {
  const previousFocusRef = useRef<HTMLElement | null>(null);

  useEffect(() => {
    if (!isOpen) return;

    const currentActiveElement = document.activeElement;
    previousFocusRef.current =
      currentActiveElement instanceof HTMLElement ? currentActiveElement : null;

    drawerRef.current?.focus();
  }, [drawerRef, isOpen]);

  useEffect(() => {
    if (isOpen) return;
    if (!previousFocusRef.current) return;
    if (!document.contains(previousFocusRef.current)) return;

    previousFocusRef.current.focus();
    previousFocusRef.current = null;
  }, [isOpen]);
};
